<!--
================================================
Composant gérant le formulaire de suppression du compte
http://localhost:8080/fr/mammouth-groupe/user/settings
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div>

        <div class="formSection " id="formSectionDeleteAccount" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

            <div class="spacer">

                <div class="contTitle has-text-left">
                    <h3 class=""><font-awesome-icon class="icon" :icon="['fas', 'skull-crossbones']" />{{$t('SuppressionDuCompte')}}</h3>
                </div>

                <form action="" v-on:keyup.enter="validateBeforeSubmit">
                    <div class="field is-horizontal">

                            <div class="control">
<!--                                <p class="help"><b>{{ $t('SupprimerDefinitivementLeCompteDeVotreOrganisationEtTout') }}</b></p>-->
                                <p class="help deleteWarning"><b>{{ $t('AttentionActionPermanenteEtIrrevocalble') }}</b></p>
                              <br>

                              <p class="help is-pulled-left helpNomOrg" v-html="$t('SaisissezLeNomDeVotreOrganisationXPourValider',{'name':organizationName})"></p>

                                <input class="input" v-model="organizationNameConfirmed"
                                       v-validate="'required|validateOrganizationNameConfirm'"
                                       data-vv-validate-on="change" id="userSetting_orgName"
                                       name="userSetting_orgName" type="text" v-bind:placeholder="$t('nomdeVotreOrganisation',{'name':organizationName})">
                                <p class="help is-danger has-text-left" id="error_userSetting_orgName">{{errors.first('userSetting_orgName') }}</p>

                            </div>

                        <!--WTF !? : j'ai ajouté le champs .dummyField input hidden car avec un seul champ sur la page je ne parvenais pas à soumettre le form avec al touche enter ! @link :https://stackoverflow.com/questions/1370021/why-does-forms-with-single-input-field-submit-upon-pressing-enter-key-in-input-->
                        <input type="text" style="display:none;" class="dummyField" >

                    </div>
                </form>


            </div>

            <div class="contFoot">
                <div class="field is-grouped">
                    <p class="control">
                        <a  v-on:click="validateBeforeSubmit" id="DeleteAccountConfirmBtn"
                            class="button is-danger btnValider" v-bind:class="{'is-loading':isSubmiting}">
                            <font-awesome-icon :icon="['fas', 'check']" class="icon"/>
                            {{$t('supprimer')}}
                        </a>
                    </p>
                </div>
            </div>

        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'UserSettingDeleteAccountComp',
        mixins: [SentryMixin, GlobalErrorNotification,InterceptorMixin, TrackingMixin],
        // components: {},
        data: function () {
            return {
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission
                organizationNameConfirmed: '', // le nom de l'organization entré dans le form pour confirmer la suppression du compte
            }
        },
        computed:{
            // https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
            // computed props for store :
            ...mapState({
                currentAccountEmail: state => state.user.currentAccountEmail,
                organizationSlug: state => state.organization.slug,
                userSlug: state => state.user.slug,
                themeToDisplay: state =>state.app.themeToDisplay

            }),
            //----------------------------------------------
            // vuex 2-way data binding forms https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
          organizationName: {
                get () {return this.$store.state.organization.name},
                set (value) { return value } // ici on ne fait rien mais requis par vueJs
            },

        },

        methods: {

            /*
             Valide que la saisie dans le champs correspond bien au nom de l'organisation
             */
            validateOrganizationNameConfirm() {
                let self = this;
                this.$validator.extend('validateOrganizationNameConfirm', {

                    getMessage() {
                        // récupération du message d'erreur dans le dictionnaire pour i18n
                        return self.$validator.dictionary.container[self.$validator.locale].custom_validator.userSetting_orgName //pas top mais je n'ai pas trouvé mieux ! (inspiré de https://github.com/baianat/vee-validate/issues/745)

                    },
                    validate() {
                      if(self.organizationName === self.organizationNameConfirmed ){
                        return true
                      }
                      else {
                        return false
                      }

                    }

                });
            },

            /*
            * Valide le formulaire avant sa soumission
            */
            validateBeforeSubmit() {

                this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        this.sendFormQuery();
                    }
                    else { // si il y a des erreurs...
                      self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        this.isSubmiting = false;
                    }

                })
            },

            /*
            Envoi la requête de soumission du formulaire
            */
            sendFormQuery(){

                let self = this;
                return self.$http
                    .delete(`organizations/${self.organizationSlug}`,
                        {headers: {Authorization: self.$auth.header()}}
                        )
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                      if(response.status === 204){
                          self.ga4GlobalEventTrack('Account deleted' , {})

                        self.$mixpanel.track("account deleted");

                            // On déconnecte l'utilisateur
                            self.$router.replace({name: 'logout',params:  {'locale':self.$route.params.locale}})

                        }

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0045'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": "error in delete account query"})
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error deleting account', 'fatal': false})

                            self.$sentry.captureMessage(`Error ${errorCode} > error in delete account query: ${error}`, 'error')
                        }
                    }).then(() =>{
                        // toujours exécuté
                        self.isSubmiting = false;
                    })

            },

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)

        created: function () {
            // activation des validateur custom pour invitation code et email
            this.validateOrganizationNameConfirm();

        },

        mounted: function () {
        },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/globalVar.scss";

#formSectionDeleteAccount{

  h3 .icon{
    color: $brandRed
  }
  .helpNomOrg{
    color: #666; font-style: normal;
  }
  .deleteWarning{
    font-style: normal !important; font-size: .8rem !important;
    background: lighten($brandRed,35%) ; padding:2px 7px; color: $brandRed !important;
  }

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {
    .deleteWarning{
      background: $darkFieldBg ; color: $brandRed !important;
    }
  }
}


</style>
